import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { FINDINGS_POSTURE, FINDINGS_THREAT_INSIGHTS } from "./findingsPaths";

/** Back-compat for /v2/findings and ?mode=threats */
export default function LegacyFindingsRedirect() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const mode = params.get("mode");
  const siteUid = params.get("site_uid");

  const base =
    mode === "threats" ? FINDINGS_THREAT_INSIGHTS : FINDINGS_POSTURE;
  const qs = siteUid ? `?site_uid=${encodeURIComponent(siteUid)}` : "";

  return <Navigate to={`${base}${qs}`} replace />;
}
